import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=dc18f1da&scoped=true&"
import script from "./editNews.vue?vue&type=script&lang=js&"
export * from "./editNews.vue?vue&type=script&lang=js&"
import style0 from "./editNews.vue?vue&type=style&index=0&id=dc18f1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc18f1da",
  null
  
)

export default component.exports